import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-mark-button",
    styleUrls: ["mark-button.component.scss"],
    templateUrl: "./mark-button.component.html"
})
export class FUIMarkButtonComponent extends FUIButtonComponent {
}
